<template>
  <swiper-container
    class="mySwiper"
    navigation="true"
    pagination="true"
    loop="true"
    autoplay-delay="5000"
    autoplay-disable-on-interaction="false"
    speed="1000"
    slides-per-view="1"
    space-between="0"
    v-if="banners.length > 0"
  >
    <swiper-slide v-for="banner in banners" :key="banner.sequencia">
      <a
        v-if="banner.link"
        :href="banner.link"
        target="_blank"
        class="banner-link"
      >
        <img
          :src="`https://${banner.banner}`"
          :alt="banner.title"
          class="banner-image"
        />
      </a>
      <img
        v-else
        :src="`https://${banner.banner}`"
        :alt="banner.title"
        class="banner-image"
      />
    </swiper-slide>
  </swiper-container>

  <!-- Fallback para quando não há banners da API -->
  <swiper-container
    class="mySwiper"
    navigation="true"
    pagination="true"
    loop="true"
    autoplay-delay="5000"
    autoplay-disable-on-interaction="false"
    speed="1000"
    slides-per-view="1"
    space-between="0"
    v-else
  >
    <swiper-slide>
      <img
        src="../../public/ban4.png"
        class="banner-image"
        alt="Banner padrão"
      />
    </swiper-slide>
  </swiper-container>
  <div class="d-flex justify-content-between">
    <h1>Product Catalog</h1>
    <div id="margin" class="row">
      <p id="ordem" class="col">Order by:</p>
      <select
        @change="onChange($event)"
        class="form-select d-inline col"
        id="orderby"
        style="width: fit-content"
        aria-label="select"
        v-model="ordenacao"
      >
        <option value="LAN%C3%87AMENTO" selected>New Arrivals</option>
        <option value="MENOR%20PRE%C3%87O">Lower Price</option>
        <option value="MAIOR%20PRE%C3%87O">Highest Price</option>
        <option value="MAIS%20VENDIDOS">Bestselling Products</option>
        <option value="MAIOR%20ESTOQUE">Most Stocked</option>
        <option value="MENOR%20ESTOQUE">Least Stocked</option>
      </select>
    </div>
  </div>
  <hr />
  <img
    v-if="topovisibility"
    @click="top"
    id="back-to-top"
    src="../../public/totop.png"
    alt="voltar ao topo botão"
  />
  <div>
    <div class="container">
      <ul style="padding: 0; min-height: 100vh">
        <div v-if="isCargando">
          <base-spinner></base-spinner>
        </div>
        <div class="row" v-if="!isCargando">
          <item-produto
            class="col-md col-6 p-1"
            v-for="produto in produtos"
            :key="produto.codigo"
            :nomeproduto="produto.nomeproduto"
            :url="produto.url"
            :detalhes="produto.detalhes"
            :preco="produto.preco"
            :saldo="produto.saldo"
            :codigo="produto.codigo"
            :textlink="produto.textlink"
            :referencia="produto.referencia"
          >
          </item-produto>
          <div
            class="text-center"
            style="margin-top: 50px"
            v-if="!isCargando && !isLoading && !acabouProdutos"
          >
            <button class="btn btn-primary my-3" @click="verMaisProdutos">
              See more
            </button>
          </div>
        </div>
        <p v-if="acabouProdutos" class="text-center text-muted my-3">
          No more products to display.
        </p>
        <div v-if="isLoading" style="margin-top: 50px">
          <base-spinner></base-spinner>
        </div>
      </ul>
    </div>
  </div>
  <sensualle-info></sensualle-info>
  <footer id="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="block">
            <p style="margin-top: 10px">Phone: +5522998679020</p>
            <p>Email: eric@sensualle.com.br</p>
            <br />
            <p>
              Developed by
              <a
                style="color: white"
                target="_blank"
                href="http://ciriuserp.com.br/"
                >Cirius ERP<img
                  style="width: 40px; margin-left: 10px"
                  src="../../public/logo.png"
                  alt="logo empresa"
              /></a>
            </p>
            <p style="margin-top: 10px">All rights reserved © 2022</p>
          </div>
        </div>
      </div>
      <br />
    </div>
  </footer>
</template>

<script>
import ItemProduto from "../components/produtos/ItemProduto.vue";
import SensualleInfo from "../components/ui/SensualleInfo.vue";
import { mapState } from "vuex";
import router from "@/router";
import { updateMetaTags, generateProductsListSeo } from "@/utils/seoManager";

export default {
  components: {
    ItemProduto,
    SensualleInfo,
  },
  data() {
    return {
      search: "",
      ordenacao: "LAN%C3%87AMENTO",
      isLoading: false,
      isCargando: false,
      topovisibility: false,
    };
  },
  computed: {
    ...mapState("empresa", ["empresarodape"]),
    ...mapState("empresa", ["banners"]),
    ...mapState("produtos", ["produtos"]),
    ...mapState("produtos", ["categoria"]),
    ...mapState("empresa", ["permissaoUsuario"]),
    ...mapState("login", ["dadosCliente"]),
    ...mapState("login", ["usuarioLogado"]),

    loja() {
      return this.$store.getters["loja/lojaSelecionada"];
    },
    tipo() {
      return this.$store.getters["loja/tipoSelecionado"];
    },
    permissaoUsuarioPage() {
      if (this.permissaoUsuario == "2") {
        return true;
      } else if (this.permissaoUsuario == "1" && this.usuarioLogado == true) {
        if (this.dadosCliente.aprovado == "S") {
          return true;
        }
        return false;
      } else return false;
    },
    acabouProdutos() {
      return this.$store.getters["produtos/acabouprodutos"] === "acabou";
    },
  },
  methods: {
    async carregarProdutos() {
      if (this.produtos.length === 0 || this.produtos.length === 4) {
        this.isLoading = true;
        await this.$store.dispatch("produtos/carregarProdutos", {
          ordem: this.ordenacao,
        });
        this.isLoading = false;
      }
    },
    async onChange(event) {
      this.ordenacao = event.target.value;
      this.isCargando = true;

      await this.$store.dispatch("loja/resetPaginacao");
      await this.$store.dispatch("produtos/resetProdutos");
      await this.$store.dispatch("produtos/carregarProdutos", {
        ordem: this.ordenacao,
      });

      this.$nextTick(() => {
        this.isCargando = false;
      });
    },
    async carregarRodape() {
      await this.$store.dispatch("empresa/carregarRodape");
      document.title = this.empresarodape.nome;
    },
    async carregarBanners() {
      await this.$store.dispatch("empresa/carregarBanners");
    },
    async carregarCategorias() {
      await this.$store.dispatch("produtos/carregarCategorias");
    },
    async resertCarousel() {
      await this.$store.dispatch("produtos/resertCarousel");
    },
    async verMaisProdutos() {
      if (this.isLoading || this.acabouProdutos) return;

      this.isLoading = true;

      await this.$store.dispatch("loja/paginacao");
      await this.$store.dispatch("produtos/carregarProdutos", {
        ordem: this.ordenacao,
      });

      this.isLoading = false;
    },
    top() {
      window.scrollTo(0, 0);
    },
    carregarPermissaoUsuario() {
      this.$store.dispatch("empresa/permissaoUsuario");
    },
  },
  created() {
    this.carregarRodape();
    this.carregarBanners();
    this.carregarProdutos();
    this.carregarCategorias();
    this.resertCarousel();
    this.carregarPermissaoUsuario();

    // Configura SEO para a página de listagem de produtos
    const seoConfig = generateProductsListSeo();
    updateMetaTags(seoConfig);
  },
  mounted() {
    if (router.currentRoute.value.fullPath == "/" + "products") {
      window.addEventListener("scroll", () => {
        if (window.scrollY >= 1145) {
          this.topovisibility = true;
        } else {
          this.topovisibility = false;
        }
      });
    }
  },
};
</script>

<style scoped>
@import "@/styles/variables.css";

@import url("https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap");

#orderby:focus {
  border-color: var(--primary-color);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #13433a;
}

#back-to-top {
  position: fixed;
  width: 80px;
  bottom: 0%;
  right: 10px;
  cursor: pointer;
}

footer {
  background-color: #232f3f;
  color: white;
  text-align: center;
  font-family: "Lato", sans-serif;
}

.fullbody {
  min-height: 100vh;
}

ul {
  list-style: none;
  margin: 2rem auto;
}

div {
  margin: 0;
  padding: 0;
  margin: auto;
  max-width: 85rem;
}

img {
  margin-left: 1rem;
}

input {
  margin: 0;
  margin: auto;
  width: 90%;
}

h1 {
  color: var(--primary-color);
  margin: 40px;
}

swiper-container {
  width: 100%;
  margin-bottom: 2rem;
}

swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.banner-link {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.banner-image {
  width: 100%;
  height: auto;
  max-width: 100%;
  display: block;
  margin: 0;
  transition: transform 0.3s ease;
}

.banner-link:hover .banner-image {
  transform: scale(1.05);
}

/* Customização dos controles do Swiper */
swiper-container::part(button-prev),
swiper-container::part(button-next) {
  color: var(--primary-color);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  margin-top: -20px;
  transition: all 0.3s ease;
}

swiper-container::part(button-prev):hover,
swiper-container::part(button-next):hover {
  background-color: var(--primary-color);
  color: white;
  transform: scale(1.1);
}

swiper-container::part(pagination) {
  bottom: 20px;
}

swiper-container::part(bullet) {
  background-color: rgba(255, 255, 255, 0.5);
  opacity: 1;
  border: 2px solid white;
  width: 12px;
  height: 12px;
}

swiper-container::part(bullet-active) {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  transform: scale(1.2);
}

button:hover,
button:active {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

button {
  font: inherit;
  cursor: pointer;
  background-color: var(--primary-color);
  color: white;
  border: 1px solid var(--primary-color);
  padding: 0.5rem 1.5rem;
  border-radius: 30px;
}
</style>
